export default "__VITE_ASSET__7558e7e8__"